import ReferanceInvestPage from "./ReferanceInvestPage";
export default ReferanceInvestPage;
